import { Emitter } from './events.js';
import { ElenweaveWorkspace } from './workspace.js';

const THEMES = {
  blueprint: {
    bg: '#061526',
    gridFine: 'rgba(64, 164, 196, 0.12)',
    gridBold: 'rgba(94, 224, 255, 0.18)',
    nodeFill: 'rgba(9, 30, 48, 0.9)',
    nodeStroke: '#6fe7ff',
    nodeGlow: 'rgba(111, 231, 255, 0.35)',
    nodeText: '#eaffff',
    edge: '#78dbff',
    edgeGlow: 'rgba(120, 219, 255, 0.35)',
    handle: '#d9f7ff',
    selection: '#41ffb4',
    preview: '#ffdb7e',
    uiText: '#eaffff',
    uiMuted: '#8db3c9',
    uiPanel: 'rgba(5, 18, 30, 0.92)',
    uiPanelBorder: 'rgba(95, 234, 255, 0.35)',
    uiHeader: 'rgba(7, 28, 44, 0.95)',
    uiInputBg: 'rgba(5, 18, 30, 0.85)',
    uiInputBorder: 'rgba(95, 234, 255, 0.25)',
    uiAccent: '#5feaff',
    uiGlow: 'rgba(95, 234, 255, 0.35)',
    uiCodeBg: 'rgba(4, 16, 28, 0.92)',
    uiCodeKw: '#3bffb1',
    uiCodeStr: '#ffdb7c',
    uiCodeNum: '#5feaff',
    uiCodeCom: '#8db3c9',
    uiCodeTag: '#7ac6ff',
    uiCodeAttr: '#a8e5ff',
    uiCodeKey: '#ffd27a',
    uiMediaBg: 'rgba(4, 16, 28, 0.92)',
    uiItemBg: 'rgba(6, 18, 30, 0.6)',
    navBg: 'rgba(8, 26, 40, 0.96)',
    navBorder: 'rgba(95, 234, 255, 0.35)',
    navGlow: 'rgba(95, 234, 255, 0.2)',
    navText: 'rgba(226, 246, 255, 0.88)',
    navHover: 'rgba(95, 234, 255, 0.7)'
  },
  light: {
    bg: '#f3f7fb',
    gridFine: 'rgba(89, 108, 128, 0.14)',
    gridBold: 'rgba(56, 76, 98, 0.2)',
    nodeFill: 'rgba(255, 255, 255, 0.95)',
    nodeStroke: '#1f2d3d',
    nodeGlow: 'rgba(31, 45, 61, 0.18)',
    nodeText: '#1a2430',
    edge: '#2a3b4f',
    edgeGlow: 'rgba(42, 59, 79, 0.2)',
    handle: '#1f2d3d',
    selection: '#1c7cff',
    preview: '#ff944d',
    uiText: '#1a2430',
    uiMuted: '#4d6377',
    uiPanel: 'rgba(248, 250, 253, 0.96)',
    uiPanelBorder: 'rgba(35, 48, 64, 0.25)',
    uiHeader: 'rgba(232, 238, 246, 0.98)',
    uiInputBg: 'rgba(245, 248, 252, 0.98)',
    uiInputBorder: 'rgba(35, 48, 64, 0.25)',
    uiAccent: '#1c7cff',
    uiGlow: 'rgba(28, 124, 255, 0.2)',
    uiCodeBg: 'rgba(238, 243, 249, 0.95)',
    uiCodeKw: '#0d5bd4',
    uiCodeStr: '#b45309',
    uiCodeNum: '#0f6fa3',
    uiCodeCom: '#7b8a99',
    uiCodeTag: '#1769aa',
    uiCodeAttr: '#3f7db8',
    uiCodeKey: '#ad6a00',
    uiMediaBg: 'rgba(238, 243, 249, 0.95)',
    uiItemBg: 'rgba(10, 18, 26, 0.08)',
    navBg: 'rgba(248, 250, 253, 0.96)',
    navBorder: 'rgba(35, 48, 64, 0.25)',
    navGlow: 'rgba(31, 45, 61, 0.12)',
    navText: 'rgba(31, 45, 61, 0.9)',
    navHover: 'rgba(28, 124, 255, 0.6)'
  },
  dark: {
    bg: '#0b0f16',
    gridFine: 'rgba(120, 136, 164, 0.08)',
    gridBold: 'rgba(148, 172, 209, 0.16)',
    nodeFill: 'rgba(16, 24, 36, 0.95)',
    nodeStroke: '#cfe0ff',
    nodeGlow: 'rgba(207, 224, 255, 0.25)',
    nodeText: '#eef3ff',
    edge: '#9fbaff',
    edgeGlow: 'rgba(159, 186, 255, 0.28)',
    handle: '#eef3ff',
    selection: '#ffb86b',
    preview: '#7be0ff',
    uiText: '#eef3ff',
    uiMuted: '#8ea3c1',
    uiPanel: 'rgba(12, 18, 28, 0.95)',
    uiPanelBorder: 'rgba(207, 224, 255, 0.22)',
    uiHeader: 'rgba(18, 26, 38, 0.95)',
    uiInputBg: 'rgba(14, 22, 34, 0.95)',
    uiInputBorder: 'rgba(207, 224, 255, 0.18)',
    uiAccent: '#9fbaff',
    uiGlow: 'rgba(159, 186, 255, 0.25)',
    uiCodeBg: 'rgba(10, 16, 26, 0.95)',
    uiCodeKw: '#9fbaff',
    uiCodeStr: '#ffb86b',
    uiCodeNum: '#7be0ff',
    uiCodeCom: '#8ea3c1',
    uiCodeTag: '#9ad1ff',
    uiCodeAttr: '#b8d8ff',
    uiCodeKey: '#ffd199',
    uiMediaBg: 'rgba(10, 16, 26, 0.95)',
    uiItemBg: 'rgba(12, 18, 28, 0.7)',
    navBg: 'rgba(12, 18, 28, 0.95)',
    navBorder: 'rgba(207, 224, 255, 0.25)',
    navGlow: 'rgba(207, 224, 255, 0.18)',
    navText: 'rgba(238, 243, 255, 0.9)',
    navHover: 'rgba(159, 186, 255, 0.6)'
  }
};

const DEFAULT_CONTEXT_MENU_ITEMS = [
  { id: 'export-json', label: 'Export as JSON', action: 'export-json' },
  { id: 'add', label: 'Add', submenu: 'add' }
];

const DEFAULT_HTML_SANITIZE_CONFIG = {
  USE_PROFILES: { html: true, svg: true, svgFilters: false },
  ADD_ATTR: ['contenteditable', 'spellcheck'],
  ALLOW_DATA_ATTR: true,
  KEEP_CONTENT: false
};

const DEFAULT_SVG_SANITIZE_CONFIG = {
  USE_PROFILES: { svg: true, svgFilters: false, html: false },
  ALLOW_DATA_ATTR: true,
  KEEP_CONTENT: false,
  FORBID_TAGS: ['script', 'foreignObject', 'iframe', 'object', 'embed']
};

function resolveDomPurify(candidate) {
  if (candidate && typeof candidate.sanitize === 'function') return candidate;
  if (typeof globalThis !== 'undefined' && globalThis.DOMPurify?.sanitize) return globalThis.DOMPurify;
  return null;
}

function escapeHtml(input) {
  return String(input)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function stripUnsafeSvg(input) {
  const svg = String(input || '');
  return svg
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/<foreignObject[\s\S]*?>[\s\S]*?<\/foreignObject>/gi, '')
    .replace(/\son\w+="[^"]*"/gi, '')
    .replace(/\son\w+='[^']*'/gi, '');
}

function resolveTheme(name, overrides = {}) {
  const base = THEMES[name] || THEMES.blueprint;
  return { ...base, ...(overrides || {}) };
}

function humanizeLabel(name) {
  if (!name) return '';
  return String(name)
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function buildContextMenuConfig(input = {}, prev = null) {
  if (input === false) return { enabled: false, items: [], addItems: [], onAction: null };
  const cfg = typeof input === 'object' ? input : {};
  const enabled = cfg.enabled ?? prev?.enabled ?? true;
  const items = cfg.items ?? prev?.items ?? DEFAULT_CONTEXT_MENU_ITEMS;
  const addItems = cfg.addItems ?? prev?.addItems ?? null;
  const onAction = cfg.onAction ?? prev?.onAction ?? null;
  return { enabled, items, addItems, onAction };
}

function isNodeFixed(node) {
  return Boolean(node?.fixed);
}

export class ElenweaveView extends Emitter {
  constructor({ canvas, workspace = null, graphId = null, options = {} }) {
    super();
    if (!canvas) throw new Error('ElenweaveView requires a canvas');
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d', { alpha: false });
    this.workspace = workspace || new ElenweaveWorkspace();
    this.graphId = graphId;
    this.graph = graphId ? this.workspace.getGraph(graphId) : this.workspace.getGraph(this.workspace.activeGraphId);
    this._themeName = options.themeName || 'blueprint';
    this._themeOverrides = options.theme || {};
    this.theme = resolveTheme(this._themeName, this._themeOverrides);
    this.gridSize = Number.isFinite(options.gridSize) ? options.gridSize : 0;
    this.minZoom = options.minZoom || 0.3;
    this.maxZoom = options.maxZoom || 2.5;
    this.snap = options.snap ?? 12;
    this._nodeColorOverride = options.nodeColor ?? null;
    this._edgeColorOverride = options.edgeColor ?? null;
    this.nodeDefaultColor = this._nodeColorOverride || this.theme.nodeStroke;
    this.edgeDefaultColor = this._edgeColorOverride || this.theme.edge;
    const edgeStyle = options.edgeStyle || 'straight';
    this.edgeStyle = ['straight', 'curved', 'mixed'].includes(edgeStyle) ? edgeStyle : 'straight';
    this.edgeCurvature = Number.isFinite(options.edgeCurvature) ? options.edgeCurvature : 0.18;
    this.linkMode = false;
    this._dirty = false;
    this._raf = null;
    this._pulseRaf = null;
    this._htmlNodes = new Map();
    this._htmlPending = new Map();
    this._htmlDirty = new Set();
    this._notifDirty = true;
    this._svgCache = new Map();
    this.registry = new Map();
    this._initRegistry(options.registry);
    this._contextMenuConfig = buildContextMenuConfig(options.contextMenu);
    this._contextMenuEnabled = this._contextMenuConfig.enabled;
    this._contextMenuPoint = null;
    this._ctxMenuItemMap = new Map();
    this._ctxMenuSubItems = new Map();
    this._contextMenuOpen = false;
    this._contextMenuDragStart = null;
    this._suppressContextMenu = false;
    this._domPurify = resolveDomPurify(options.domPurify || options.sanitizer);
    this._sanitizeHtml = options.sanitizeHtml ?? true;
    this._sanitizeSvg = options.sanitizeSvg ?? true;
    this._allowUntrustedComponents = options.allowUntrustedComponents ?? true;
    const htmlConfig = options.sanitizeConfig?.html || {};
    const svgConfig = options.sanitizeConfig?.svg || {};
    this._sanitizeConfig = {
      html: { ...DEFAULT_HTML_SANITIZE_CONFIG, ...htmlConfig },
      svg: { ...DEFAULT_SVG_SANITIZE_CONFIG, ...svgConfig }
    };
    this._warnedSanitizer = false;
    this._virtualize = options.virtualize ?? false;
    this._virtualizePadding = Number.isFinite(options.virtualizePadding) ? options.virtualizePadding : 200;
    this._virtualizeEdges = options.virtualizeEdges ?? true;
    this._visibleNodeIds = null;
    this._visibleEdges = null;
    this._visibleNodes = null;

    this.camera = { x: 120, y: 120, s: 1 };
    this.state = {
      hoverId: null,
      selectedId: null,
      selectedEdgeId: null,
      dragId: null,
      dragOff: { x: 0, y: 0 },
      resizingId: null,
      resizeHandle: null,
      linking: { active: false, fromId: null, worldX: 0, worldY: 0 },
      panning: false,
      panStart: { x: 0, y: 0 },
      camStart: { x: 0, y: 0 },
      spaceDown: false
    };

    this._attachDom();
    this._applyThemeVars();
    this._bindWorkspace();
    this._invalidate();
  }

  _bindWorkspace() {
    if (!this.graphId) {
      this.workspace.on('graph:active', (graph) => {
        this.graph = graph;
        this.state.selectedId = null;
        this.state.selectedEdgeId = null;
        this._clearHtmlNodes();
        this._clearSvgNodes();
        this._notifDirty = true;
        this._invalidate();
      });
    }
  }

  _attachDom() {
    const container = this.canvas.parentElement;
    this._container = container || null;
    this._focused = false;
    if (this._container) {
      this._container.style.position = this._container.style.position || 'relative';
      this._container.tabIndex = 0;
    }

    this.overlay = document.createElement('div');
    this.overlay.className = 'ew-html-layer';
    (this._container || document.body).appendChild(this.overlay);

    this.inlineEditor = document.createElement('textarea');
    this.inlineEditor.className = 'bp-inline-editor';
    this.inlineEditor.spellcheck = false;
    this.inlineEditor.style.display = 'none';
    (this._container || document.body).appendChild(this.inlineEditor);

    this._confirmBackdrop = document.createElement('div');
    this._confirmBackdrop.className = 'ew-confirm-backdrop';
    this._confirmBackdrop.style.display = 'none';
    this._confirmBackdrop.addEventListener('pointerdown', (e) => {
      if (e.target === this._confirmBackdrop) this._hideDeleteConfirm();
    });

    this._confirmModal = document.createElement('div');
    this._confirmModal.className = 'ew-confirm-modal';

    this._confirmTitle = document.createElement('div');
    this._confirmTitle.className = 'ew-confirm-title';
    this._confirmTitle.textContent = 'Delete node';

    this._confirmText = document.createElement('div');
    this._confirmText.className = 'ew-confirm-text';
    this._confirmText.textContent = 'Delete selected node?';

    this._confirmActions = document.createElement('div');
    this._confirmActions.className = 'ew-confirm-actions';

    this._confirmCancel = document.createElement('button');
    this._confirmCancel.type = 'button';
    this._confirmCancel.className = 'ew-confirm-btn secondary';
    this._confirmCancel.textContent = 'Cancel';
    this._confirmCancel.addEventListener('click', () => this._hideDeleteConfirm());

    this._confirmConfirm = document.createElement('button');
    this._confirmConfirm.type = 'button';
    this._confirmConfirm.className = 'ew-confirm-btn danger';
    this._confirmConfirm.textContent = 'Delete';

    this._confirmActions.append(this._confirmCancel, this._confirmConfirm);
    this._confirmModal.append(this._confirmTitle, this._confirmText, this._confirmActions);
    this._confirmBackdrop.appendChild(this._confirmModal);
    (this._container || document.body).appendChild(this._confirmBackdrop);

    this._notifRoot = document.createElement('div');
    this._notifRoot.className = 'ew-notif-cluster';
    this._notifRoot.addEventListener('pointerdown', (e) => e.stopPropagation());

    this._notifIcon = document.createElement('button');
    this._notifIcon.type = 'button';
    this._notifIcon.className = 'ew-notif-icon';
    this._notifIcon.setAttribute('aria-label', 'Notifications');
    this._notifIcon.setAttribute('aria-expanded', 'true');
    const iconDot = document.createElement('span');
    iconDot.className = 'ew-notif-dot';
    this._notifIcon.appendChild(iconDot);
    this._notifIcon.addEventListener('click', (e) => this._toggleNotifications(e));

    this._notifList = document.createElement('div');
    this._notifList.className = 'ew-notif-list';
    this._boundNotifClick = (e) => this._onNotificationClick(e);
    this._notifList.addEventListener('click', this._boundNotifClick);

    this._notifRoot.append(this._notifIcon, this._notifList);
    (this._container || document.body).appendChild(this._notifRoot);
    this._notifCollapsed = false;

    this._contextMenu = document.createElement('div');
    this._contextMenu.className = 'ew-context-menu';
    this._contextMenu.setAttribute('role', 'menu');
    this._contextMenu.style.display = 'none';
    this._contextMenu.addEventListener('pointerdown', (e) => e.stopPropagation());

    this._contextMenuMain = document.createElement('div');
    this._contextMenuMain.className = 'ew-context-menu-list';
    this._contextMenuMain.addEventListener('click', (e) => this._onContextMenuClick(e));
    this._contextMenuMain.addEventListener('pointerenter', (e) => this._onContextMenuHover(e), true);

    this._contextMenuSub = document.createElement('div');
    this._contextMenuSub.className = 'ew-context-submenu';
    this._contextMenuSub.addEventListener('click', (e) => this._onContextMenuClick(e));

    this._contextMenu.append(this._contextMenuMain, this._contextMenuSub);
    (this._container || document.body).appendChild(this._contextMenu);

    this.canvas.addEventListener('pointerdown', this._onPointerDown);
    this.overlay.addEventListener('pointerdown', this._onOverlayPointerDown, true);
    if (this._container) {
      this._container.addEventListener('focusin', this._onFocusIn);
      this._container.addEventListener('focusout', this._onFocusOut);
    } else {
      this._focused = true;
    }
    window.addEventListener('pointermove', this._onPointerMove);
    window.addEventListener('pointerup', this._onPointerUp);
    this.canvas.addEventListener('wheel', this._onWheel, { passive: false });
    this.canvas.addEventListener('dblclick', this._onDoubleClick);
    this.canvas.addEventListener('contextmenu', this._onContextMenu);
    window.addEventListener('pointerdown', this._onGlobalPointerDown, true);
    window.addEventListener('keydown', this._onGlobalKeyDown);
    if (this._container) {
      this._container.addEventListener('keydown', this._onKeyDown);
      this._container.addEventListener('keyup', this._onKeyUp);
    } else {
      window.addEventListener('keydown', this._onKeyDown);
      window.addEventListener('keyup', this._onKeyUp);
    }
  }

  destroy() {
    this.canvas.removeEventListener('pointerdown', this._onPointerDown);
    window.removeEventListener('pointermove', this._onPointerMove);
    window.removeEventListener('pointerup', this._onPointerUp);
    this.canvas.removeEventListener('wheel', this._onWheel);
    this.canvas.removeEventListener('dblclick', this._onDoubleClick);
    this.canvas.removeEventListener('contextmenu', this._onContextMenu);
    window.removeEventListener('pointerdown', this._onGlobalPointerDown, true);
    window.removeEventListener('keydown', this._onGlobalKeyDown);
    if (this.overlay) {
      this.overlay.removeEventListener('pointerdown', this._onOverlayPointerDown, true);
      if (this.overlay.parentElement) this.overlay.parentElement.removeChild(this.overlay);
    }
    if (this._notifList && this._boundNotifClick) {
      this._notifList.removeEventListener('click', this._boundNotifClick);
    }
    if (this._notifRoot?.parentElement) this._notifRoot.parentElement.removeChild(this._notifRoot);
    if (this._contextMenu?.parentElement) this._contextMenu.parentElement.removeChild(this._contextMenu);
    this._clearSvgNodes();
    if (this._container) {
      this._container.removeEventListener('focusin', this._onFocusIn);
      this._container.removeEventListener('focusout', this._onFocusOut);
      this._container.removeEventListener('keydown', this._onKeyDown);
      this._container.removeEventListener('keyup', this._onKeyUp);
    } else {
      window.removeEventListener('keydown', this._onKeyDown);
      window.removeEventListener('keyup', this._onKeyUp);
    }
    if (this.inlineEditor?.parentElement) this.inlineEditor.parentElement.removeChild(this.inlineEditor);
  }

  setLinkMode(active) {
    this.linkMode = Boolean(active);
    this.emit('mode:link', this.linkMode);
  }

  invalidate() {
    this._invalidate();
  }

  isFocused() {
    return this._focused;
  }

  getContainer() {
    return this._container || this.canvas;
  }

  getThemeName() {
    return this._themeName;
  }

  setTheme(nameOrOverrides, overrides = {}) {
    if (typeof nameOrOverrides === 'string') {
      this._themeName = nameOrOverrides;
      this._themeOverrides = { ...this._themeOverrides, ...(overrides || {}) };
    } else if (nameOrOverrides && typeof nameOrOverrides === 'object') {
      this._themeOverrides = { ...this._themeOverrides, ...nameOrOverrides };
    }
    this.theme = resolveTheme(this._themeName, this._themeOverrides);
    this.nodeDefaultColor = this._nodeColorOverride || this.theme.nodeStroke;
    this.edgeDefaultColor = this._edgeColorOverride || this.theme.edge;
    this._applyThemeVars();
    this._invalidate();
  }

  setEdgeStyle(style = 'straight') {
    const next = ['straight', 'curved', 'mixed'].includes(style) ? style : 'straight';
    if (this.edgeStyle === next) return;
    this.edgeStyle = next;
    this._invalidate();
  }

  setEdgeCurvature(value = 0) {
    if (!Number.isFinite(value)) return;
    this.edgeCurvature = value;
    if (this.edgeStyle === 'curved') this._invalidate();
  }

  setVirtualization({ enabled, padding, edges } = {}) {
    if (typeof enabled === 'boolean') this._virtualize = enabled;
    if (Number.isFinite(padding)) this._virtualizePadding = Math.max(0, padding);
    if (typeof edges === 'boolean') this._virtualizeEdges = edges;
    this._invalidate();
  }

  getVirtualizationConfig() {
    return {
      enabled: Boolean(this._virtualize),
      padding: this._virtualizePadding,
      edges: Boolean(this._virtualizeEdges)
    };
  }

  setContextMenuConfig(config = {}) {
    this._contextMenuConfig = buildContextMenuConfig(config, this._contextMenuConfig);
    this._contextMenuEnabled = this._contextMenuConfig.enabled;
    if (!this._contextMenuEnabled) this._hideContextMenu();
  }

  enableContextMenu() {
    this._contextMenuEnabled = true;
  }

  disableContextMenu() {
    this._contextMenuEnabled = false;
    this._hideContextMenu();
  }

  _applyThemeVars() {
    const target = this._container || document.documentElement;
    if (!target) return;
    const t = this.theme || {};
    const style = target.style;
    style.setProperty('--ew-ui-text', t.uiText || t.nodeText || '#eaffff');
    style.setProperty('--ew-ui-muted', t.uiMuted || '#8db3c9');
    style.setProperty('--ew-ui-panel', t.uiPanel || t.nodeFill || 'rgba(5, 18, 30, 0.92)');
    style.setProperty('--ew-ui-panel-border', t.uiPanelBorder || t.nodeStroke || '#6fe7ff');
    style.setProperty('--ew-ui-header', t.uiHeader || t.uiPanel || 'rgba(7, 28, 44, 0.95)');
    style.setProperty('--ew-ui-input-bg', t.uiInputBg || t.nodeFill || 'rgba(5, 18, 30, 0.85)');
    style.setProperty('--ew-ui-input-border', t.uiInputBorder || t.nodeStroke || 'rgba(95, 234, 255, 0.25)');
    style.setProperty('--ew-ui-accent', t.uiAccent || t.selection || '#41ffb4');
    style.setProperty('--ew-ui-glow', t.uiGlow || t.nodeGlow || 'rgba(95, 234, 255, 0.35)');
    style.setProperty('--ew-ui-code-bg', t.uiCodeBg || 'rgba(4, 16, 28, 0.92)');
    style.setProperty('--ew-ui-code-kw', t.uiCodeKw || '#3bffb1');
    style.setProperty('--ew-ui-code-str', t.uiCodeStr || '#ffdb7c');
    style.setProperty('--ew-ui-code-num', t.uiCodeNum || t.edge || '#5feaff');
    style.setProperty('--ew-ui-code-com', t.uiCodeCom || t.uiMuted || '#8db3c9');
    style.setProperty('--ew-ui-code-tag', t.uiCodeTag || '#7ac6ff');
    style.setProperty('--ew-ui-code-attr', t.uiCodeAttr || '#a8e5ff');
    style.setProperty('--ew-ui-code-key', t.uiCodeKey || '#ffd27a');
    style.setProperty('--ew-ui-media-bg', t.uiMediaBg || t.uiCodeBg || 'rgba(4, 16, 28, 0.92)');
    style.setProperty('--ew-ui-item-bg', t.uiItemBg || 'rgba(6, 18, 30, 0.6)');
    style.setProperty('--ew-ui-anchor', t.uiAccent || t.selection || '#5feaff');
    style.setProperty('--ew-ui-anchor-glow', t.uiGlow || t.nodeGlow || 'rgba(95, 234, 255, 0.35)');
    style.setProperty('--ew-ui-handle', t.handle || '#d9f7ff');
    style.setProperty('--ew-nav-bg', t.navBg || t.uiPanel || 'rgba(8, 26, 40, 0.96)');
    style.setProperty('--ew-nav-border', t.navBorder || t.uiPanelBorder || 'rgba(95, 234, 255, 0.35)');
    style.setProperty('--ew-nav-glow', t.navGlow || t.uiGlow || 'rgba(95, 234, 255, 0.2)');
    style.setProperty('--ew-nav-text', t.navText || t.uiText || 'rgba(226, 246, 255, 0.88)');
    style.setProperty('--ew-nav-hover', t.navHover || t.uiAccent || 'rgba(95, 234, 255, 0.7)');
  }

  registerComponent(name, definition) {
    if (!name) return;
    const normalized = this._normalizeComponentEntry(definition);
    if (!normalized) return;
    this.registry.set(name, normalized);
  }

  unregisterComponent(name) {
    this.registry.delete(name);
  }

  selectNode(id) {
    if (!this.graph) return;
    const hadEdge = this.state.selectedEdgeId != null;
    this.state.selectedId = id || null;
    this.state.selectedEdgeId = null;
    const node = id ? this.graph.getNode(id) : null;
    this.emit('selection', node);
    if (hadEdge) this.emit('edge:selection', null);
    this._invalidate();
  }

  selectEdge(id) {
    if (!this.graph) return;
    const hadNode = this.state.selectedId != null;
    this.state.selectedEdgeId = id || null;
    this.state.selectedId = null;
    const edge = id ? this.graph.edges.find((e) => e.id === id) : null;
    this.emit('edge:selection', edge || null);
    if (hadNode) this.emit('selection', null);
    this._invalidate();
  }

  setActiveGraph(id) {
    if (this.graphId) return;
    this.workspace.setActiveGraph(id);
  }

  addNode(partial = {}) {
    if (!this.graph) return null;
    const id = this.graph.addNode(partial);
    const node = this.graph.getNode(id);
    if (node?.type === 'html') this._htmlDirty.add(id);
    this._invalidate();
    return id;
  }

  addNodes(partials = []) {
    if (!this.graph || !Array.isArray(partials)) return [];
    const ids = this.graph.addNodes(partials);
    ids.forEach((id) => {
      const node = this.graph.getNode(id);
      if (node?.type === 'html' || node?.type === 'html-text') this._htmlDirty.add(id);
    });
    if (ids.length) this._invalidate();
    return ids;
  }

  updateNode(id, patch = {}) {
    if (!this.graph) return null;
    const node = this.graph.updateNode(id, patch);
    if (node?.type === 'html' || node?.type === 'html-text') {
      this._htmlDirty.add(id);
    } else if (this._htmlNodes.has(id)) {
      this._removeHtmlNode(id);
    }
    this._invalidate();
    return node;
  }

  updateNodes(entries = []) {
    if (!this.graph || !Array.isArray(entries)) return [];
    const updated = this.graph.updateNodes(entries);
    updated.forEach((node) => {
      if (node?.type === 'html' || node?.type === 'html-text') {
        this._htmlDirty.add(node.id);
      } else if (this._htmlNodes.has(node?.id)) {
        this._removeHtmlNode(node.id);
      }
    });
    if (updated.length) this._invalidate();
    return updated;
  }

  removeNode(id) {
    if (!this.graph) return false;
    const removed = this.graph.removeNode(id);
    if (removed && this.state.selectedId === id) {
      this.state.selectedId = null;
      this.emit('selection', null);
    }
    if (removed) this._removeHtmlNode(id);
    if (removed) this._removeSvgNode(id);
    if (removed) this._notifDirty = true;
    this._invalidate();
    return removed;
  }

  removeEdge(edgeId) {
    if (!this.graph) return false;
    const removed = this.graph.removeEdge(edgeId);
    if (removed && this.state.selectedEdgeId === edgeId) {
      this.state.selectedEdgeId = null;
      this.emit('edge:selection', null);
    }
    this._invalidate();
    return removed;
  }

  addEdge(from, to, opts = {}) {
    if (!this.graph) return null;
    const id = this.graph.addEdge(from, to, opts);
    this._invalidate();
    return id;
  }

  addEdges(entries = []) {
    if (!this.graph || !Array.isArray(entries)) return [];
    const ids = this.graph.addEdges(entries);
    if (ids.length) this._invalidate();
    return ids;
  }

  updateEdge(edgeId, patch = {}) {
    if (!this.graph) return null;
    const edge = this.graph.updateEdge(edgeId, patch);
    this._invalidate();
    return edge;
  }

  updateEdges(entries = []) {
    if (!this.graph || !Array.isArray(entries)) return [];
    const updated = this.graph.updateEdges(entries);
    if (updated.length) this._invalidate();
    return updated;
  }

  exportGraph() {
    if (!this.graph) return null;
    return this.graph.serialize();
  }

  exportWorkspace() {
    return this.workspace.exportWorkspace();
  }

  importGraph(data, options = {}) {
    const id = this.workspace.importGraph(data, options);
    if (!id) return null;
    if (!this.graphId && (options.makeActive || this.workspace.activeGraphId === id)) {
      this.graph = this.workspace.getGraph(id);
      this._clearHtmlNodes();
      this._notifDirty = true;
      this._invalidate();
    }
    return id;
  }

  importWorkspace(data, options = {}) {
    const ok = this.workspace.importWorkspace(data, options);
    if (!ok) return false;
    if (!this.graphId) {
      this.graph = this.workspace.getGraph(this.workspace.activeGraphId);
      this._clearHtmlNodes();
      this._notifDirty = true;
      this._invalidate();
    }
    return true;
  }

  addNotification({ nodeId, label = null, timestamp = null } = {}) {
    if (!this.graph) return null;
    const id = this.graph.addNotification({ nodeId, label, timestamp });
    if (id) {
      this._notifDirty = true;
      this.emit('notification:added', { id, nodeId, label, timestamp: timestamp || Date.now() });
      this._invalidate();
    }
    return id;
  }

  markNotificationRead(id, read = true) {
    if (!this.graph || !id) return null;
    const notif = this.graph.markNotificationRead(id, read);
    if (notif) {
      this._notifDirty = true;
      this.emit('notification:read', notif);
      this._invalidate();
    }
    return notif;
  }

  clearNotifications() {
    if (!this.graph) return;
    this.graph.clearNotifications();
    this._notifDirty = true;
    this.emit('notification:cleared', null);
    this._invalidate();
  }

  getNotifications() {
    if (!this.graph) return [];
    return this.graph.notifications.map((n) => ({ ...n }));
  }

  deleteSelected() {
    if (this.state.selectedId) {
      const node = this.graph?.getNode(this.state.selectedId);
      this._showDeleteConfirm(node);
      return;
    }
    if (this.state.selectedEdgeId) this.removeEdge(this.state.selectedEdgeId);
  }

  focusNode(id) {
    const node = this.graph?.getNode(id);
    if (!node) return;
    this.camera.x = -(node.x + node.w / 2) * this.camera.s + this.canvas.clientWidth / 2;
    this.camera.y = -(node.y + node.h / 2) * this.camera.s + this.canvas.clientHeight / 2;
    this._invalidate();
  }

  moveTo(id) {
    if (!id) return;
    this.selectNode(id);
    const node = this.graph?.getNode(id);
    if (!node) return;
    const target = this._cameraCenterFor(node);
    this._animateCameraTo(target.x, target.y, 240);
  }

  _showDeleteConfirm(node) {
    if (!this._confirmBackdrop || !this._confirmConfirm) {
      if (node?.id) this.removeNode(node.id);
      return;
    }
    if (this._confirmOpen) return;
    if (!node?.id) return;

    const label = node.text ? `Delete "${node.text}"?` : 'Delete selected node?';
    this._confirmText.textContent = label;
    this._confirmOpen = true;
    this._confirmBackdrop.style.display = 'flex';

    this._confirmConfirm.onclick = () => {
      this._hideDeleteConfirm();
      this.removeNode(node.id);
    };

    this._confirmKeyHandler = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        this._hideDeleteConfirm();
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        this._confirmConfirm.click();
      }
    };
    window.addEventListener('keydown', this._confirmKeyHandler);
    this._confirmConfirm.focus();
  }

  _hideDeleteConfirm() {
    if (!this._confirmBackdrop) return;
    this._confirmBackdrop.style.display = 'none';
    this._confirmOpen = false;
    if (this._confirmKeyHandler) {
      window.removeEventListener('keydown', this._confirmKeyHandler);
      this._confirmKeyHandler = null;
    }
  }

  _cameraCenterFor(node) {
    return {
      x: -(node.x + node.w / 2) * this.camera.s + this.canvas.clientWidth / 2,
      y: -(node.y + node.h / 2) * this.camera.s + this.canvas.clientHeight / 2
    };
  }

  _animateCameraTo(targetX, targetY, duration = 240) {
    if (this._moveRaf) cancelAnimationFrame(this._moveRaf);
    const startX = this.camera.x;
    const startY = this.camera.y;
    const start = performance.now();

    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      this.camera.x = startX + (targetX - startX) * eased;
      this.camera.y = startY + (targetY - startY) * eased;
      this._invalidate();
      if (t < 1) {
        this._moveRaf = requestAnimationFrame(step);
      } else {
        this._moveRaf = null;
      }
    };

    this._moveRaf = requestAnimationFrame(step);
  }

  _invalidate() {
    if (this._dirty) return;
    this._dirty = true;
    this._raf = requestAnimationFrame(() => {
      this._dirty = false;
      this.render();
    });
  }

  worldToScreen(wx, wy) {
    return { x: wx * this.camera.s + this.camera.x, y: wy * this.camera.s + this.camera.y };
  }

  screenToWorld(sx, sy) {
    return { x: (sx - this.camera.x) / this.camera.s, y: (sy - this.camera.y) / this.camera.s };
  }

  _pickNode(sx, sy) {
    if (!this.graph) return null;
    const p = this.screenToWorld(sx, sy);
    const nodes = this._visibleNodeIds ? this._visibleNodesArray() : this.graph.nodes;
    for (let i = nodes.length - 1; i >= 0; i--) {
      const n = nodes[i];
      if (p.x >= n.x && p.x <= n.x + n.w && p.y >= n.y && p.y <= n.y + n.h) return n.id;
    }
    return null;
  }

  _pickEdge(sx, sy) {
    if (!this.graph) return null;
    let best = null;
    let bestDist = Infinity;
    const edges = this._visibleEdges && !this._dirty ? this._visibleEdges : this.graph.edges;
    for (const e of edges) {
      const from = this.graph.getNode(e.from);
      const to = this.graph.getNode(e.to);
      if (!from || !to) continue;
      const a = this._edgeAnchor(from, to);
      const b = this._edgeAnchor(to, from);
      const curve = this._edgeCurve(e);
      let d = Infinity;
      if (curve) {
        const control = this._edgeControlPoint(a.x, a.y, b.x, b.y, curve);
        if (control) {
          const steps = 12;
          let prev = this.worldToScreen(a.x, a.y);
          for (let i = 1; i <= steps; i++) {
            const t = i / steps;
            const p = this._quadraticPoint(a, control, b, t);
            const ps = this.worldToScreen(p.x, p.y);
            const seg = this._distanceToSegment(sx, sy, prev.x, prev.y, ps.x, ps.y);
            if (seg < d) d = seg;
            prev = ps;
          }
        }
      } else {
        const as = this.worldToScreen(a.x, a.y);
        const bs = this.worldToScreen(b.x, b.y);
        d = this._distanceToSegment(sx, sy, as.x, as.y, bs.x, bs.y);
      }
      if (d < 8 && d < bestDist) {
        best = e.id;
        bestDist = d;
      }
    }
    return best;
  }

  _distanceToSegment(px, py, ax, ay, bx, by) {
    const dx = bx - ax;
    const dy = by - ay;
    if (dx === 0 && dy === 0) return Math.hypot(px - ax, py - ay);
    const t = ((px - ax) * dx + (py - ay) * dy) / (dx * dx + dy * dy);
    const clamped = Math.max(0, Math.min(1, t));
    const cx = ax + clamped * dx;
    const cy = ay + clamped * dy;
    return Math.hypot(px - cx, py - cy);
  }

  _eventPoint(e) {
    const rect = this.canvas.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  }

  _onFocusIn = () => {
    this._focused = true;
  };

  _onFocusOut = (e) => {
    if (!this._container) return;
    if (this._container.contains(e.relatedTarget)) return;
    this._focused = false;
  };

  _onOverlayPointerDown = (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;
    const nodeEl = target.closest('[data-ew-node-id]');
    if (!nodeEl) return;
    const nodeId = nodeEl.getAttribute('data-ew-node-id');
    if (!nodeId) return;
    const node = this.graph?.getNode(nodeId);
    const fixed = isNodeFixed(node);
    if (this._container) this._container.focus({ preventScroll: true });

    const resizeHandle = target.closest('[data-ew-resize]');
    if (resizeHandle) {
      const handle = resizeHandle.getAttribute('data-ew-resize');
      if (!handle) return;
      if (fixed) {
        this.selectNode(nodeId);
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      this._startHtmlResize(nodeId, handle, e);
      return;
    }

    const isInteractive = target.closest('input, textarea, select, button, a, [contenteditable="true"]');
    const wantsLink = (this.linkMode || e.shiftKey) && e.button === 0;
    const wantsAnchorLink = Boolean(target.closest('[data-ew-link]')) && e.button === 0;
    if ((wantsAnchorLink || wantsLink) && !isInteractive) {
      e.preventDefault();
      e.stopPropagation();
      const p = this._eventPoint(e);
      const world = this.screenToWorld(p.x, p.y);
      this.state.linking = { active: true, fromId: nodeId, worldX: world.x, worldY: world.y };
      this.selectNode(nodeId);
      this._invalidate();
      return;
    }

    const dragHandle = target.closest('[data-ew-drag]');
    if (dragHandle && !isInteractive) {
      if (fixed) {
        this.selectNode(nodeId);
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      this._startHtmlDrag(nodeId, e);
      return;
    }

    const selectEl = target.closest('[data-ew-select]');
    if (selectEl) {
      this.selectNode(nodeId);
    }
  };

  _startHtmlResize(nodeId, handle, e) {
    if (!this.graph) return;
    const node = this.graph.getNode(nodeId);
    if (!node || isNodeFixed(node)) return;
    this.state.resizingId = nodeId;
    this.state.resizeHandle = handle;
    this.selectNode(nodeId);
    const p = this._eventPoint(e);
    const world = this.screenToWorld(p.x, p.y);
    this.state.dragOff = { x: world.x - node.x, y: world.y - node.y };
    this._invalidate();
  }

  _startHtmlDrag(nodeId, e) {
    if (!this.graph) return;
    const node = this.graph.getNode(nodeId);
    if (!node || isNodeFixed(node)) return;
    const p = this._eventPoint(e);
    const world = this.screenToWorld(p.x, p.y);
    this.state.dragId = nodeId;
    this.state.dragOff = { x: world.x - node.x, y: world.y - node.y };
    this.selectNode(nodeId);
    this._invalidate();
  }

  _handlePositions(n) {
    const p = this.worldToScreen(n.x, n.y);
    const w = n.w * this.camera.s;
    const h = n.h * this.camera.s;
    return {
      nw: { x: p.x, y: p.y },
      ne: { x: p.x + w, y: p.y },
      se: { x: p.x + w, y: p.y + h },
      sw: { x: p.x, y: p.y + h }
    };
  }

  _hitHandle(n, sx, sy) {
    const hs = 8;
    const pos = this._handlePositions(n);
    for (const key of ['nw', 'ne', 'se', 'sw']) {
      const h = pos[key];
      if (Math.abs(sx - h.x) <= hs && Math.abs(sy - h.y) <= hs) return key;
    }
    return null;
  }

  _onPointerDown = (e) => {
    if (this._container) this._container.focus({ preventScroll: true });
    if (!this.graph) return;
    this._hideContextMenu();
    this.inlineEditor.style.display = 'none';
    const p = this._eventPoint(e);
    if (e.button === 2) {
      this._contextMenuDragStart = { x: p.x, y: p.y };
      this._suppressContextMenu = false;
    } else {
      this._contextMenuDragStart = null;
    }
    const id = this._pickNode(p.x, p.y);
    const node = id ? this.graph.getNode(id) : null;
    const edgeId = !id ? this._pickEdge(p.x, p.y) : null;
    const fixed = isNodeFixed(node);

    if (node && !fixed) {
      const handle = this._hitHandle(node, p.x, p.y);
      if (handle) {
        this.state.resizingId = id;
        this.state.resizeHandle = handle;
        return;
      }
    }

    if (!node && edgeId) {
      this.selectEdge(edgeId);
      return;
    }

    if (!node && !edgeId && e.button === 0) {
      this.selectNode(null);
    }

    const wantsLink = (this.linkMode || e.shiftKey) && id && e.button === 0;
    if (wantsLink) {
      const world = this.screenToWorld(p.x, p.y);
      this.state.linking = { active: true, fromId: id, worldX: world.x, worldY: world.y };
      this._invalidate();
      return;
    }

    const wantsPan = e.button === 1 || e.button === 2 || e.altKey || this.state.spaceDown || (!id && e.button === 0);
    if (wantsPan) {
      this.state.panning = true;
      this.state.panStart = { x: p.x, y: p.y };
      this.state.camStart = { x: this.camera.x, y: this.camera.y };
      return;
    }

    if (id && e.button === 0 && !fixed) {
      this.state.dragId = id;
      const world = this.screenToWorld(p.x, p.y);
      this.state.dragOff = { x: world.x - node.x, y: world.y - node.y };
      this.selectNode(id);
      this._invalidate();
    } else {
      if (id) this.selectNode(id);
      else this.selectNode(null);
      this._invalidate();
    }
  };

  _onPointerMove = (e) => {
    if (!this.graph) return;
    const p = this._eventPoint(e);
    const { resizingId, resizeHandle } = this.state;
    if (resizingId) {
      const n = this.graph.getNode(resizingId);
      if (n && !isNodeFixed(n)) {
        const world = this.screenToWorld(p.x, p.y);
        const snap = this.snap;
        const right = n.x + n.w;
        const bottom = n.y + n.h;
        if (resizeHandle === 'se') {
          n.w = Math.max(80, Math.round((world.x - n.x) / snap) * snap);
          n.h = Math.max(50, Math.round((world.y - n.y) / snap) * snap);
        } else if (resizeHandle === 'ne') {
          const newW = Math.max(80, Math.round((world.x - n.x) / snap) * snap);
          const newY = Math.round(world.y / snap) * snap;
          n.w = newW;
          n.h = Math.max(50, Math.round((bottom - newY) / snap) * snap);
          n.y = bottom - n.h;
        } else if (resizeHandle === 'sw') {
          const newH = Math.max(50, Math.round((world.y - n.y) / snap) * snap);
          const newX = Math.round(world.x / snap) * snap;
          n.w = Math.max(80, Math.round((right - newX) / snap) * snap);
          n.x = right - n.w;
          n.h = newH;
        } else if (resizeHandle === 'nw') {
          const newX = Math.round(world.x / snap) * snap;
          const newY = Math.round(world.y / snap) * snap;
          n.w = Math.max(80, Math.round((right - newX) / snap) * snap);
          n.h = Math.max(50, Math.round((bottom - newY) / snap) * snap);
          n.x = right - n.w;
          n.y = bottom - n.h;
        }
        this._invalidate();
      }
      return;
    }

    if (this.state.linking.active) {
      const world = this.screenToWorld(p.x, p.y);
      this.state.linking.worldX = world.x;
      this.state.linking.worldY = world.y;
      this._invalidate();
      return;
    }

    if (this.state.panning) {
      this.camera.x = this.state.camStart.x + (p.x - this.state.panStart.x);
      this.camera.y = this.state.camStart.y + (p.y - this.state.panStart.y);
      if (this._contextMenuDragStart) {
        const dx = p.x - this._contextMenuDragStart.x;
        const dy = p.y - this._contextMenuDragStart.y;
        if (dx * dx + dy * dy > 36) this._suppressContextMenu = true;
      }
      this._invalidate();
      return;
    }

    if (this.state.dragId) {
      const n = this.graph.getNode(this.state.dragId);
      if (n && !isNodeFixed(n)) {
        const world = this.screenToWorld(p.x, p.y);
        n.x = Math.round((world.x - this.state.dragOff.x) / this.snap) * this.snap;
        n.y = Math.round((world.y - this.state.dragOff.y) / this.snap) * this.snap;
        this._invalidate();
      }
      return;
    }

    const id = this._pickNode(p.x, p.y);
    this.state.hoverId = id;
    this._invalidate();
  };

  _onPointerUp = (e) => {
    if (!this.graph) return;
    if (this.state.linking.active) {
      const p = this._eventPoint(e);
      const targetId = this._pickNode(p.x, p.y);
      if (targetId && targetId !== this.state.linking.fromId) {
        this.addEdge(this.state.linking.fromId, targetId);
      }
      this.state.linking = { active: false, fromId: null, worldX: 0, worldY: 0 };
      this._invalidate();
      return;
    }

    this.state.dragId = null;
    this.state.resizingId = null;
    this.state.resizeHandle = null;
    this.state.panning = false;
    this._contextMenuDragStart = null;
    this._invalidate();
  };

  _onWheel = (e) => {
    e.preventDefault();
    const delta = Math.sign(e.deltaY) * -0.1;
    const prev = this.camera.s;
    this.camera.s = Math.min(this.maxZoom, Math.max(this.minZoom, this.camera.s * (1 + delta)));
    const scale = this.camera.s / prev;
    const p = this._eventPoint(e);
    const mx = p.x;
    const my = p.y;
    this.camera.x = mx - (mx - this.camera.x) * scale;
    this.camera.y = my - (my - this.camera.y) * scale;
    this._invalidate();
  };

  _onDoubleClick = (e) => {
    if (!this.graph) return;
    const p = this._eventPoint(e);
    const id = this._pickNode(p.x, p.y);
    const node = id ? this.graph.getNode(id) : null;
    if (node && node.type === 'text') this._startInlineEdit(node);
  };

  _onKeyDown = (e) => {
    if (e.key === ' ') this.state.spaceDown = true;
    if ((e.key === 'Enter' || e.key === 'F2') && this.state.selectedId) {
      if (document.activeElement === this.inlineEditor) return;
      const node = this.graph?.getNode(this.state.selectedId);
      if (node && node.type === 'text') {
        e.preventDefault();
        this._startInlineEdit(node);
      }
    }
    if (e.key === 'Delete') {
      if (this._confirmOpen) return;
      const active = document.activeElement;
      const isTextInput = active && (
        active.tagName === 'INPUT' ||
        active.tagName === 'TEXTAREA' ||
        active.tagName === 'SELECT' ||
        active.isContentEditable ||
        active.closest?.('[contenteditable="true"]')
      );
      if (isTextInput) return;
      if (this.state.selectedId || this.state.selectedEdgeId) this.deleteSelected();
    }
  };

  _onKeyUp = (e) => {
    if (e.key === ' ') this.state.spaceDown = false;
  };

  _onGlobalPointerDown = (e) => {
    if (!this._contextMenuOpen) return;
    const target = e.target;
    if (target instanceof Node && this._contextMenu?.contains(target)) return;
    this._hideContextMenu();
  };

  _onGlobalKeyDown = (e) => {
    if (e.key === 'Escape' && this._contextMenuOpen) {
      this._hideContextMenu();
    }
  };

  _onContextMenu = (e) => {
    if (!this._contextMenuEnabled) return;
    if (!this.graph) return;
    if (this._suppressContextMenu) {
      this._suppressContextMenu = false;
      return;
    }
    e.preventDefault();
    const p = this._eventPoint(e);
    const id = this._pickNode(p.x, p.y);
    const edgeId = !id ? this._pickEdge(p.x, p.y) : null;
    if (id || edgeId) {
      this._hideContextMenu();
      return;
    }
    this.selectNode(null);
    this._contextMenuPoint = {
      screenX: p.x,
      screenY: p.y,
      clientX: e.clientX,
      clientY: e.clientY,
      worldX: this.screenToWorld(p.x, p.y).x,
      worldY: this.screenToWorld(p.x, p.y).y
    };
    this._showContextMenu(p.x, p.y, e);
  };

  _startInlineEdit(node) {
    const pos = this.worldToScreen(node.x, node.y);
    const w = Math.round(node.w * this.camera.s);
    const h = Math.round(node.h * this.camera.s);
    this.inlineEditor.style.display = 'block';
    this.inlineEditor.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
    this.inlineEditor.style.width = `${Math.max(120, w - 2)}px`;
    this.inlineEditor.style.height = `${Math.max(40, h - 2)}px`;
    this.inlineEditor.value = node.text || '';
    this.inlineEditor.dataset.nodeId = node.id;
    this.inlineEditor.focus();

    this.inlineEditor.onblur = () => this._finishInlineEdit();
    this.inlineEditor.onkeydown = (ev) => {
      if (ev.key === 'Enter' && !ev.shiftKey) {
        ev.preventDefault();
        this.inlineEditor.blur();
      }
      if (ev.key === 'Escape') {
        this.inlineEditor.value = node.text || '';
        this.inlineEditor.blur();
      }
    };
  }

  _finishInlineEdit() {
    const id = this.inlineEditor.dataset.nodeId;
    const node = this.graph?.getNode(id);
    if (node) node.text = this.inlineEditor.value.trim() || 'Untitled';
    this.inlineEditor.dataset.nodeId = '';
    this.inlineEditor.style.display = 'none';
    this._invalidate();
  }

  render() {
    if (!this.graph) return;
    const ctx = this.ctx;
    const rect = this.canvas.getBoundingClientRect();
    const dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
    const w = Math.floor(rect.width * dpr);
    const h = Math.floor(rect.height * dpr);
    if (this.canvas.width !== w || this.canvas.height !== h) {
      this.canvas.width = w;
      this.canvas.height = h;
    }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, rect.width, rect.height);

    ctx.fillStyle = this.theme.bg;
    ctx.fillRect(0, 0, rect.width, rect.height);

    if (this.gridSize > 0) this._drawGrid(rect.width, rect.height);
    this._computeVisibleSets(rect.width, rect.height);
    this._drawEdges();
    this._drawNodes();
    this._drawLinkPreview();
    this._syncHtmlNodes();
    this._syncNotifications();
    this._ensurePulseLoop();
  }

  _drawGrid(width, height) {
    const ctx = this.ctx;
    const grid = this.gridSize * this.camera.s;
    const bold = grid * 5;
    const offsetX = this.camera.x % grid;
    const offsetY = this.camera.y % grid;

    ctx.beginPath();
    for (let x = offsetX; x < width; x += grid) {
      ctx.moveTo(x, 0);
      ctx.lineTo(x, height);
    }
    for (let y = offsetY; y < height; y += grid) {
      ctx.moveTo(0, y);
      ctx.lineTo(width, y);
    }
    ctx.strokeStyle = this.theme.gridFine;
    ctx.lineWidth = 1;
    ctx.stroke();

    const boldX = this.camera.x % bold;
    const boldY = this.camera.y % bold;
    ctx.beginPath();
    for (let x = boldX; x < width; x += bold) {
      ctx.moveTo(x, 0);
      ctx.lineTo(x, height);
    }
    for (let y = boldY; y < height; y += bold) {
      ctx.moveTo(0, y);
      ctx.lineTo(width, y);
    }
    ctx.strokeStyle = this.theme.gridBold;
    ctx.lineWidth = 1;
    ctx.stroke();
  }

  _computeVisibleSets(width, height) {
    if (!this.graph) return;
    if (!this._virtualize) {
      this._visibleNodeIds = null;
      this._visibleEdges = null;
      this._visibleNodes = null;
      return;
    }
    const pad = this._virtualizePadding;
    const topLeft = this.screenToWorld(-pad, -pad);
    const bottomRight = this.screenToWorld(width + pad, height + pad);
    const minX = Math.min(topLeft.x, bottomRight.x);
    const maxX = Math.max(topLeft.x, bottomRight.x);
    const minY = Math.min(topLeft.y, bottomRight.y);
    const maxY = Math.max(topLeft.y, bottomRight.y);

    const visible = new Set();
    for (const node of this.graph.nodes) {
      if (
        node.x + node.w >= minX &&
        node.x <= maxX &&
        node.y + node.h >= minY &&
        node.y <= maxY
      ) {
        visible.add(node.id);
      }
    }

    if (this.state.selectedId) visible.add(this.state.selectedId);
    if (this.state.dragId) visible.add(this.state.dragId);
    if (this.state.linking.active && this.state.linking.fromId) visible.add(this.state.linking.fromId);
    if (this.state.resizingId) visible.add(this.state.resizingId);

    const visibleNodes = [];
    for (const node of this.graph.nodes) {
      if (visible.has(node.id)) visibleNodes.push(node);
    }
    this._visibleNodeIds = visible;
    this._visibleNodes = visibleNodes;
    if (this._virtualizeEdges) {
      const visibleEdges = [];
      for (const edge of this.graph.edges) {
        if (visible.has(edge.from) || visible.has(edge.to)) visibleEdges.push(edge);
      }
      this._visibleEdges = visibleEdges;
    } else {
      this._visibleEdges = null;
    }
  }

  _visibleNodesArray() {
    if (!this._virtualize || !this._visibleNodes || this._dirty) return this.graph ? this.graph.nodes : [];
    return this._visibleNodes;
  }

  _drawEdges() {
    const ctx = this.ctx;
    const edges = this._visibleEdges || this.graph.edges;
    for (const e of edges) {
      const from = this.graph.getNode(e.from);
      const to = this.graph.getNode(e.to);
      if (!from || !to) continue;
      const a = this._edgeAnchor(from, to);
      const b = this._edgeAnchor(to, from);
      const curve = this._edgeCurve(e);
      const baseColor = e.color || this.edgeDefaultColor;
      const pulse = e.pulse ? this._pulseValue(e.id) : 0;
      const width = 1.2 + pulse * 1.4;
      const glow = e.pulse ? baseColor : this.theme.edgeGlow;
      const blur = e.pulse ? 14 + pulse * 14 : 10;
      this._drawArrow(a.x, a.y, b.x, b.y, baseColor, glow, {
        width,
        blur,
        alpha: e.pulse ? 0.55 + pulse * 0.45 : 1,
        curve
      });

      if (this.state.selectedEdgeId === e.id) {
        this._drawArrow(a.x, a.y, b.x, b.y, this.theme.selection, this.theme.selection, {
          width: width + 1.5,
          blur: 16,
          alpha: 0.75,
          curve
        });
      }

      if (e.label) {
        this._drawEdgeLabel(a, b, e.label, e, curve);
      }
    }
  }

  _drawEdgeLabel(a, b, text, edge, curve = 0) {
    const ctx = this.ctx;
    const offset = 10;
    let world = null;
    if (curve) {
      const control = this._edgeControlPoint(a.x, a.y, b.x, b.y, curve);
      if (control) {
        const mid = this._quadraticPoint(a, control, b, 0.5);
        const tan = this._quadraticTangent(a, control, b, 0.5);
        const len = Math.hypot(tan.x, tan.y) || 1;
        const nx = -tan.y / len;
        const ny = tan.x / len;
        world = { x: mid.x + nx * offset, y: mid.y + ny * offset };
      }
    }
    if (!world) {
      const mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      const dx = b.x - a.x;
      const dy = b.y - a.y;
      const len = Math.hypot(dx, dy) || 1;
      const nx = -dy / len;
      const ny = dx / len;
      world = { x: mid.x + nx * offset, y: mid.y + ny * offset };
    }
    const p = this.worldToScreen(world.x, world.y);

    const fontSize = clampValue(8, 14, 10 * this.camera.s);
    ctx.save();
    ctx.font = `600 ${fontSize}px "Space Grotesk", "Share Tech Mono", monospace`;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    const label = String(text);
    const metrics = ctx.measureText(label);
    const padX = 6;
    const padY = 4;
    const boxW = metrics.width + padX * 2;
    const boxH = fontSize + padY * 2;
    ctx.fillStyle = this.theme.uiPanel || 'rgba(6, 18, 30, 0.85)';
    ctx.strokeStyle = this.theme.uiPanelBorder || this.theme.edge;
    ctx.lineWidth = 1;
    ctx.globalAlpha = edge?.pulse ? 0.9 : 0.85;
    ctx.beginPath();
    if (ctx.roundRect) {
      ctx.roundRect(p.x - boxW / 2, p.y - boxH / 2, boxW, boxH, 6);
    } else {
      ctx.rect(p.x - boxW / 2, p.y - boxH / 2, boxW, boxH);
    }
    ctx.fill();
    ctx.stroke();
    ctx.globalAlpha = 1;
    ctx.fillStyle = this.theme.uiText || this.theme.nodeText;
    ctx.fillText(label, p.x, p.y);
    ctx.restore();
  }

  _drawNodes() {
    const ctx = this.ctx;
    const { hoverId, selectedId } = this.state;
    const nodes = this._virtualize ? this._visibleNodesArray() : this.graph.nodes;

    for (const n of nodes) {
      const p = this.worldToScreen(n.x, n.y);
      const w = n.w * this.camera.s;
      const h = n.h * this.camera.s;

      ctx.save();
      const borderColor = n.color || this.nodeDefaultColor;
      const pulse = n.pulse ? this._pulseValue(n.id) : 0;
      ctx.shadowColor = n.pulse ? borderColor : this.theme.nodeGlow;
      ctx.shadowBlur = (hoverId === n.id || selectedId === n.id) ? 18 : 8;
      if (n.pulse) ctx.shadowBlur += 14 * pulse;
      ctx.fillStyle = this.theme.nodeFill;
      ctx.strokeStyle = borderColor;
      ctx.lineWidth = 1;
      this._drawNodeRect(p.x, p.y, w, h, 6);
      ctx.restore();

      if (n.pulse) {
        ctx.save();
        ctx.strokeStyle = borderColor;
        ctx.globalAlpha = 0.3 + pulse * 0.5;
        ctx.lineWidth = 2 + pulse * 1.5;
        ctx.shadowColor = borderColor;
        ctx.shadowBlur = 16 + pulse * 18;
        this._drawNodeRect(p.x - 1, p.y - 1, w + 2, h + 2, 6, false);
        ctx.restore();
      }

      if (hoverId === n.id || selectedId === n.id) {
        ctx.save();
        ctx.strokeStyle = this.theme.selection;
        ctx.lineWidth = 1.5;
        this._drawNodeRect(p.x - 1, p.y - 1, w + 2, h + 2, 6, false);
        ctx.restore();
      }

      if (n.type === 'text') {
        const pad = Math.max(4, 10 * this.camera.s);
        this._drawWrappedText(n.text || '', p.x + pad, p.y + pad, w - pad * 2, 16);
      } else if (n.type === 'html-text') {
        // HTML-backed text renders via overlay component.
      } else if (n.type === 'image') {
        ctx.save();
        ctx.strokeStyle = this.theme.nodeStroke;
        ctx.setLineDash([6, 6]);
        ctx.strokeRect(p.x + 6, p.y + 6, w - 12, h - 12);
        ctx.restore();
      } else if (n.type === 'svg') {
        this._drawSvgNode(n, p, w, h);
      } else if (n.type === 'audio') {
        const pad = Math.max(4, 10 * this.camera.s);
        this._drawWrappedText(n.text || 'Audio', p.x + pad, p.y + pad, w - pad * 2, 16);
      }

      if (selectedId === n.id && !isNodeFixed(n)) this._drawHandles(n);
    }
  }

  _drawNodeRect(x, y, w, h, radius = 0, fill = true) {
    const ctx = this.ctx;
    const r = Math.max(0, Math.min(radius, Math.min(w, h) / 2));
    ctx.beginPath();
    if (r && ctx.roundRect) {
      ctx.roundRect(x, y, w, h, r);
    } else if (r) {
      ctx.moveTo(x + r, y);
      ctx.lineTo(x + w - r, y);
      ctx.quadraticCurveTo(x + w, y, x + w, y + r);
      ctx.lineTo(x + w, y + h - r);
      ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      ctx.lineTo(x + r, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - r);
      ctx.lineTo(x, y + r);
      ctx.quadraticCurveTo(x, y, x + r, y);
    } else {
      ctx.rect(x, y, w, h);
    }
    if (fill) ctx.fill();
    ctx.stroke();
  }

  _drawSvgNode(node, p, w, h) {
    const ctx = this.ctx;
    const record = this._getSvgRecord(node);
    const pad = Math.max(6, 10 * this.camera.s);
    const innerW = Math.max(0, w - pad * 2);
    const innerH = Math.max(0, h - pad * 2);

    if (!record || record.error) {
      ctx.save();
      ctx.strokeStyle = this.theme.nodeStroke;
      ctx.setLineDash([6, 6]);
      ctx.strokeRect(p.x + pad, p.y + pad, innerW, innerH);
      ctx.restore();
      return;
    }

    if (!record.loaded || !record.img?.complete) {
      ctx.save();
      ctx.strokeStyle = this.theme.nodeStroke;
      ctx.setLineDash([6, 6]);
      ctx.strokeRect(p.x + pad, p.y + pad, innerW, innerH);
      ctx.restore();
      return;
    }

    const img = record.img;
    const iw = img.naturalWidth || 1;
    const ih = img.naturalHeight || 1;
    const scale = Math.min(innerW / iw, innerH / ih);
    const dw = iw * scale;
    const dh = ih * scale;
    const dx = p.x + (w - dw) / 2;
    const dy = p.y + (h - dh) / 2;
    ctx.drawImage(img, dx, dy, dw, dh);
  }

  _drawHandles(n) {
    const ctx = this.ctx;
    const size = 8;
    const pos = this._handlePositions(n);
    ctx.fillStyle = this.theme.handle;
    for (const key of ['nw', 'ne', 'se', 'sw']) {
      const h = pos[key];
      ctx.fillRect(h.x - size / 2, h.y - size / 2, size, size);
    }
  }

  _drawLinkPreview() {
    if (!this.state.linking.active) return;
    const from = this.graph.getNode(this.state.linking.fromId);
    if (!from) return;
    const anchor = this._edgeAnchor(from, { x: this.state.linking.worldX, y: this.state.linking.worldY, w: 0, h: 0 });
    const curve = this._edgeCurve(null);
    this._drawArrow(anchor.x, anchor.y, this.state.linking.worldX, this.state.linking.worldY, this.theme.preview, this.theme.preview, { curve });
  }

  _edgeCurve(edge) {
    if (this.edgeStyle === 'straight') return 0;
    if (this.edgeStyle === 'mixed') {
      return Number.isFinite(edge?.curve) ? edge.curve : 0;
    }
    if (Number.isFinite(edge?.curve)) return edge.curve;
    return Number.isFinite(this.edgeCurvature) ? this.edgeCurvature : 0;
  }

  _edgeControlPoint(ax, ay, bx, by, curve) {
    if (!curve) return null;
    const mx = (ax + bx) / 2;
    const my = (ay + by) / 2;
    const dx = bx - ax;
    const dy = by - ay;
    const len = Math.hypot(dx, dy) || 1;
    const nx = -dy / len;
    const ny = dx / len;
    const bend = curve * len;
    return { x: mx + nx * bend, y: my + ny * bend };
  }

  _quadraticPoint(a, c, b, t) {
    const mt = 1 - t;
    const mt2 = mt * mt;
    const t2 = t * t;
    return {
      x: mt2 * a.x + 2 * mt * t * c.x + t2 * b.x,
      y: mt2 * a.y + 2 * mt * t * c.y + t2 * b.y
    };
  }

  _quadraticTangent(a, c, b, t) {
    const mt = 1 - t;
    return {
      x: 2 * mt * (c.x - a.x) + 2 * t * (b.x - c.x),
      y: 2 * mt * (c.y - a.y) + 2 * t * (b.y - c.y)
    };
  }

  _edgeAnchor(from, to) {
    const cx = from.x + from.w / 2;
    const cy = from.y + from.h / 2;
    const tx = to.x + (to.w || 0) / 2;
    const ty = to.y + (to.h || 0) / 2;
    const dx = tx - cx;
    const dy = ty - cy;
    if (dx === 0 && dy === 0) return { x: cx, y: cy };
    const hw = from.w / 2;
    const hh = from.h / 2;
    const adx = Math.abs(dx);
    const ady = Math.abs(dy);
    const scale = (adx / hw > ady / hh) ? (hw / adx) : (hh / ady);
    return { x: cx + dx * scale, y: cy + dy * scale };
  }

  _drawArrow(ax, ay, bx, by, color, glow, opts = {}) {
    const ctx = this.ctx;
    const a = this.worldToScreen(ax, ay);
    const b = this.worldToScreen(bx, by);
    const width = opts.width || 1.2;
    const alpha = opts.alpha ?? 1;
    const blur = opts.blur ?? 10;
    const curve = opts.curve ?? 0;
    const control = curve ? this._edgeControlPoint(ax, ay, bx, by, curve) : null;
    const c = control ? this.worldToScreen(control.x, control.y) : null;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = width;
    ctx.shadowColor = glow;
    ctx.shadowBlur = blur;
    ctx.globalAlpha = alpha;
    ctx.beginPath();
    ctx.moveTo(a.x, a.y);
    if (c) {
      ctx.quadraticCurveTo(c.x, c.y, b.x, b.y);
    } else {
      ctx.lineTo(b.x, b.y);
    }
    ctx.stroke();
    ctx.restore();

    const headLen = Math.max(6, 10 * Math.min(1.4, this.camera.s));
    const angle = c ? Math.atan2(b.y - c.y, b.x - c.x) : Math.atan2(b.y - a.y, b.x - a.x);
    ctx.fillStyle = color;
    ctx.globalAlpha = alpha;
    ctx.beginPath();
    ctx.moveTo(b.x, b.y);
    ctx.lineTo(b.x - headLen * Math.cos(angle - Math.PI / 6), b.y - headLen * Math.sin(angle - Math.PI / 6));
    ctx.lineTo(b.x - headLen * Math.cos(angle + Math.PI / 6), b.y - headLen * Math.sin(angle + Math.PI / 6));
    ctx.closePath();
    ctx.fill();
    ctx.globalAlpha = 1;
  }

  _initRegistry(registry) {
    if (!registry) return;
    if (registry instanceof Map) {
      registry.forEach((value, key) => this.registerComponent(key, value));
      return;
    }
    if (Array.isArray(registry)) {
      registry.forEach((entry) => {
        if (!entry) return;
        const [key, value] = entry;
        if (key) this.registerComponent(key, value);
      });
      return;
    }
    if (typeof registry === 'object') {
      Object.entries(registry).forEach(([key, value]) => {
        this.registerComponent(key, value);
      });
    }
  }

  _syncHtmlNodes() {
    if (!this.overlay || !this.graph) return;
    const active = new Set();
    const visible = this._visibleNodeIds;
    const nodes = this._virtualize ? this._visibleNodesArray() : this.graph.nodes;
    for (const node of nodes) {
      if (node.type !== 'html' && node.type !== 'html-text') continue;
      active.add(node.id);
      const record = this._htmlNodes.get(node.id);
      const key = this._componentKey(node);
      const needsRemount = !record || !this._sameComponentKey(record.key, key);
      if (needsRemount) {
        this._removeHtmlNode(node.id);
        this._mountHtmlNode(node, key);
        continue;
      }

      if (this._htmlDirty.has(node.id)) {
        if (record.update) {
          record.update(node, this._componentApi(node));
          this._sanitizeHtmlElement(record.el);
        } else {
          this._removeHtmlNode(node.id);
          this._mountHtmlNode(node, key);
          continue;
        }
        this._htmlDirty.delete(node.id);
      }

      if (record?.el) {
        this._positionHtmlNode(node, record.el);
        this._syncHtmlSelection(node, record);
      }
    }

    for (const [id] of this._htmlNodes) {
      if (!active.has(id)) this._removeHtmlNode(id);
    }
  }

  _syncNotifications() {
    if (!this._notifRoot || !this.graph) return;
    if (!this._notifDirty) return;
    this._notifDirty = false;
    const notifs = Array.isArray(this.graph.notifications)
      ? [...this.graph.notifications].sort((a, b) => b.timestamp - a.timestamp)
      : [];
    const hasUnread = notifs.some((n) => !n.read);
    this._notifRoot.classList.toggle('has-unread', hasUnread);
    this._notifRoot.classList.toggle('is-empty', notifs.length === 0);
    this._notifRoot.classList.toggle('is-collapsed', this._notifCollapsed);
    this._notifList.innerHTML = '';
    notifs.forEach((n) => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'ew-notif-item';
      item.dataset.ewNotif = n.id;
      if (n.read) item.classList.add('is-read');
      else item.classList.add('is-unread');
      const exists = this.graph.getNode(n.nodeId);
      if (!exists) item.classList.add('is-missing');

      const label = document.createElement('span');
      label.className = 'ew-notif-label';
      label.textContent = n.label || `Node ${n.nodeId}`;

      const meta = document.createElement('span');
      meta.className = 'ew-notif-time';
      meta.textContent = this._formatNotificationTime(n.timestamp);

      item.append(label, meta);
      this._notifList.appendChild(item);
    });
  }

  _componentKey(node) {
    return {
      type: node.type || 'html',
      component: node.component || null,
      render: node.render || null,
      loader: node.loader || null
    };
  }

  _normalizeComponentEntry(entry) {
    if (!entry) return null;
    if (typeof entry === 'function') return { render: entry, trusted: true };
    if (entry.render || entry.loader) {
      return { ...entry, trusted: entry.trusted !== false };
    }
    return { render: entry, trusted: true };
  }

  _isComponentUntrusted(node, entry) {
    if (node?.trusted === false) return true;
    if (entry?.trusted === false) return true;
    return false;
  }

  _sameComponentKey(a, b) {
    if (!a || !b) return false;
    return a.type === b.type && a.component === b.component && a.render === b.render && a.loader === b.loader;
  }

  async _mountHtmlNode(node, key) {
    const token = Symbol('html-node');
    this._htmlPending.set(node.id, token);
    let definition = null;
    try {
      definition = await this._resolveComponent(node);
    } catch (err) {
      console.error('HTML node loader failed', err);
    }
    if (this._htmlPending.get(node.id) !== token) return;
    if (!this.graph || !this.graph.getNode(node.id)) return;
    const { el, update, cleanup } = this._instantiateComponent(definition, node);
    const element = el || this._fallbackNode(node, 'Component failed');
    element.dataset.ewNodeId = node.id;
    if (!element.dataset.ewSelect) element.dataset.ewSelect = 'true';
    if (!element.dataset.ewDrag) element.dataset.ewDrag = 'true';
    element.classList.add('ew-html-node');
    element.style.position = 'absolute';
    element.style.pointerEvents = 'auto';
    this.overlay.appendChild(element);
    const record = { el: element, update, cleanup, key };
    this._attachHtmlHandles(record);
    this._htmlNodes.set(node.id, record);
    this._htmlDirty.delete(node.id);
    this._positionHtmlNode(node, element);
    this._syncHtmlSelection(node, record);
  }

  async _resolveComponent(node) {
    if ((node?.trusted === false) && !this._allowUntrustedComponents && (node.render || node.loader)) {
      console.warn('Blocked untrusted inline component');
      return { render: () => this._fallbackNode(node, 'Untrusted component blocked') };
    }
    if (typeof node.render === 'function') return { render: node.render };
    if (typeof node.loader === 'function') return node.loader();
    if (node.component && this.registry.has(node.component)) {
      const entry = this.registry.get(node.component);
      if (this._isComponentUntrusted(node, entry) && !this._allowUntrustedComponents) {
        console.warn(`Blocked untrusted component "${node.component}"`);
        return { render: () => this._fallbackNode(node, 'Untrusted component blocked') };
      }
      if (entry?.loader) return entry.loader();
      if (entry?.render) return entry;
      return { render: entry };
    }
    if (node.type === 'html-text') return { render: this._renderHtmlTextNode.bind(this) };
    return null;
  }

  _instantiateComponent(definition, node) {
    if (!definition) return { el: this._fallbackNode(node, 'Component missing') };
    const api = this._componentApi(node);
    let renderFn = null;

    if (typeof definition === 'function') {
      renderFn = definition;
    } else if (typeof definition.render === 'function') {
      renderFn = definition.render;
    } else if (typeof definition.default === 'function') {
      renderFn = definition.default;
    }

    if (!renderFn) return { el: this._fallbackNode(node, 'Invalid component') };

    let result = null;
    try {
      result = renderFn({ node, api });
    } catch (err) {
      console.error('HTML node render failed', err);
      return { el: this._fallbackNode(node, 'Render error') };
    }

    if (result instanceof HTMLElement) {
      this._sanitizeHtmlElement(result);
      return { el: result };
    }
    if (result && result.el instanceof HTMLElement) {
      this._sanitizeHtmlElement(result.el);
      return result;
    }
    if (typeof result === 'string') {
      const wrap = document.createElement('div');
      wrap.innerHTML = this._sanitizeHtmlMarkup(result);
      return { el: wrap };
    }
    return { el: this._fallbackNode(node, 'Empty component') };
  }

  _fallbackNode(node, message) {
    const el = document.createElement('div');
    el.className = 'ew-html-fallback';
    el.textContent = message || 'Missing component';
    return el;
  }

  _sanitizeHtmlMarkup(markup) {
    if (!this._sanitizeHtml || markup == null) return markup;
    const purifier = this._domPurify;
    if (purifier?.sanitize) {
      try {
        return purifier.sanitize(markup, this._sanitizeConfig.html);
      } catch (err) {
        console.warn('HTML sanitize failed', err);
      }
    } else if (!this._warnedSanitizer) {
      console.warn('DOMPurify unavailable, falling back to escaped HTML.');
      this._warnedSanitizer = true;
    }
    return escapeHtml(markup);
  }

  _sanitizeHtmlElement(element) {
    if (!this._sanitizeHtml || !element) return element;
    const purifier = this._domPurify;
    if (purifier?.sanitize) {
      try {
        purifier.sanitize(element, { ...this._sanitizeConfig.html, IN_PLACE: true });
      } catch (err) {
        console.warn('HTML sanitize failed', err);
      }
    } else if (!this._warnedSanitizer) {
      console.warn('DOMPurify unavailable, skipping HTML element sanitize.');
      this._warnedSanitizer = true;
    }
    return element;
  }

  _sanitizeSvgMarkup(markup) {
    if (!this._sanitizeSvg || markup == null) return markup;
    const purifier = this._domPurify;
    if (purifier?.sanitize) {
      try {
        return purifier.sanitize(markup, this._sanitizeConfig.svg);
      } catch (err) {
        console.warn('SVG sanitize failed', err);
      }
    } else if (!this._warnedSanitizer) {
      console.warn('DOMPurify unavailable, using basic SVG sanitizer.');
      this._warnedSanitizer = true;
    }
    return stripUnsafeSvg(markup);
  }

  _componentApi(node) {
    return {
      setData: (patch) => {
        const current = this.graph?.getNode(node.id);
        if (!current) return;
        const data = { ...(current.data || {}), ...patch };
        this.updateNode(node.id, { data });
      },
      emit: (event, payload) => this.emit(event, payload)
    };
  }

  _renderHtmlTextNode({ node }) {
    const wrap = document.createElement('div');
    wrap.className = 'ew-html-text';
    wrap.dataset.ewSelect = 'true';
    wrap.dataset.ewDrag = 'true';

    const anchorLeft = document.createElement('span');
    anchorLeft.className = 'ew-link-anchor ew-link-anchor-left';
    anchorLeft.dataset.ewLink = 'true';
    anchorLeft.setAttribute('aria-label', 'Link from left');

    const anchorRight = document.createElement('span');
    anchorRight.className = 'ew-link-anchor ew-link-anchor-right';
    anchorRight.dataset.ewLink = 'true';
    anchorRight.setAttribute('aria-label', 'Link from right');

    const editor = document.createElement('div');
    editor.className = 'ew-html-text-editor';
    editor.contentEditable = 'false';
    editor.spellcheck = false;
    editor.textContent = node.text || '';

    const setEditing = (active) => {
      const next = Boolean(active);
      editor.contentEditable = next ? 'true' : 'false';
      wrap.classList.toggle('is-editing', next);
      if (next) editor.focus();
    };

    const syncText = () => {
      const value = editor.textContent ?? '';
      if (value === (node.text || '')) return;
      this.updateNode(node.id, { text: value });
    };
    editor.addEventListener('input', syncText);
    editor.addEventListener('blur', () => {
      syncText();
      setEditing(false);
    });
    editor.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        setEditing(false);
        editor.blur();
      }
    });
    wrap.addEventListener('dblclick', (e) => {
      e.stopPropagation();
      setEditing(true);
    });

    const update = (nextNode) => {
      if (document.activeElement === editor) return;
      editor.textContent = nextNode.text || '';
    };

    wrap.append(anchorLeft, editor, anchorRight);
    return { el: wrap, update };
  }

  _onNotificationClick(e) {
    const target = e.target instanceof HTMLElement ? e.target.closest('[data-ew-notif]') : null;
    if (!target) return;
    const id = target.getAttribute('data-ew-notif');
    if (!id || !this.graph) return;
    const notif = this.graph.notifications.find((n) => n.id === id);
    if (!notif) return;
    if (!notif.read) this.markNotificationRead(id, true);
    if (notif.nodeId && this.graph.getNode(notif.nodeId)) {
      this.moveTo(notif.nodeId);
    }
  }

  _toggleNotifications(e) {
    if (e) e.preventDefault();
    this._notifCollapsed = !this._notifCollapsed;
    if (this._notifIcon) {
      this._notifIcon.setAttribute('aria-expanded', this._notifCollapsed ? 'false' : 'true');
    }
    if (this._notifRoot) {
      this._notifRoot.classList.toggle('is-collapsed', this._notifCollapsed);
    }
  }

  _formatNotificationTime(timestamp) {
    const ts = Number.isFinite(timestamp) ? timestamp : Date.now();
    const date = new Date(ts);
    const now = new Date();
    const sameDay = date.toDateString() === now.toDateString();
    const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    if (sameDay) return time;
    const day = date.toLocaleDateString([], { month: 'short', day: '2-digit' });
    return `${day} ${time}`;
  }

  _contextMenuContext() {
    const point = this._contextMenuPoint || { screenX: 0, screenY: 0, worldX: 0, worldY: 0 };
    return {
      view: this,
      graph: this.graph,
      screen: { x: point.screenX, y: point.screenY },
      world: { x: point.worldX, y: point.worldY },
      registry: this.registry,
      addItems: this._resolveAddItems()
    };
  }

  _resolveAddItems() {
    const cfgItems = this._contextMenuConfig?.addItems;
    if (Array.isArray(cfgItems) && cfgItems.length) return cfgItems;
    const items = [];
    items.push({
      id: 'add-html-text',
      label: 'Editable Text',
      nodeType: 'html-text',
      text: 'Editable text',
      size: { w: 320, h: 160 }
    });
    this.registry.forEach((_, key) => {
      items.push({
        id: `add-${key}`,
        label: humanizeLabel(key) || key,
        nodeType: 'html',
        component: key
      });
    });
    return items;
  }

  _resolveMenuItems(items, ctx) {
    if (!items) return [];
    const list = typeof items === 'function' ? items(ctx) : items;
    if (!Array.isArray(list)) return [];
    const out = [];
    list.forEach((item) => {
      if (!item) return;
      if (typeof item === 'function') {
        const resolved = item(ctx);
        if (Array.isArray(resolved)) out.push(...resolved.filter(Boolean));
        else if (resolved) out.push(resolved);
        return;
      }
      if (typeof item === 'string') {
        out.push({ id: item, label: humanizeLabel(item), action: item });
        return;
      }
      out.push(item);
    });
    return out;
  }

  _menuIdFor(item, fallback) {
    const raw = item.id || item.action || item.label || fallback || 'item';
    return String(raw)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  _buildContextMenu() {
    if (!this._contextMenuMain) return;
    const ctx = this._contextMenuContext();
    const items = this._resolveMenuItems(this._contextMenuConfig?.items || DEFAULT_CONTEXT_MENU_ITEMS, ctx);
    this._ctxMenuItemMap.clear();
    this._ctxMenuSubItems.clear();
    this._contextMenuMain.innerHTML = '';
    this._contextMenuSub.innerHTML = '';
    this._contextMenuSub.style.display = 'none';

    items.forEach((item, index) => {
      const id = this._menuIdFor(item, `item-${index}`);
      const menuItem = { ...item, id };
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ew-context-item';
      btn.dataset.ewMenuId = id;
      btn.textContent = menuItem.label || menuItem.id;
      if (menuItem.enabled === false) btn.disabled = true;

      let submenuItems = null;
      if (menuItem.submenu) {
        if (menuItem.submenu === 'add') submenuItems = ctx.addItems;
        else if (typeof menuItem.submenu === 'function') submenuItems = menuItem.submenu(ctx);
        else if (Array.isArray(menuItem.submenu)) submenuItems = menuItem.submenu;
      }

      if (Array.isArray(submenuItems) && submenuItems.length) {
        btn.dataset.ewSubmenu = 'true';
        btn.classList.add('has-submenu');
        this._ctxMenuSubItems.set(id, submenuItems);
      } else if (menuItem.submenu) {
        btn.disabled = true;
      }

      this._ctxMenuItemMap.set(id, menuItem);
      this._contextMenuMain.appendChild(btn);
    });
  }

  _showContextMenu(x, y, e) {
    if (!this._contextMenu) return;
    this._buildContextMenu();
    this._contextMenu.style.display = 'block';
    this._contextMenuOpen = true;
    const container = this._container || document.body;
    const containerRect = container.getBoundingClientRect();
    const menuRect = this._contextMenu.getBoundingClientRect();
    const offsetX = this._container ? x : e?.clientX || containerRect.left;
    const offsetY = this._container ? y : e?.clientY || containerRect.top;
    let left = offsetX;
    let top = offsetY;
    if (left + menuRect.width > containerRect.width) left = containerRect.width - menuRect.width - 8;
    if (top + menuRect.height > containerRect.height) top = containerRect.height - menuRect.height - 8;
    left = Math.max(8, left);
    top = Math.max(8, top);
    this._contextMenu.style.left = `${left}px`;
    this._contextMenu.style.top = `${top}px`;
  }

  _hideContextMenu() {
    if (!this._contextMenu) return;
    this._contextMenu.style.display = 'none';
    this._contextMenuOpen = false;
    if (this._contextMenuSub) this._contextMenuSub.style.display = 'none';
  }

  _onContextMenuHover(e) {
    const target = e.target instanceof HTMLElement ? e.target.closest('[data-ew-menu-id]') : null;
    if (!target || !this._contextMenuMain) return;
    const id = target.dataset.ewMenuId;
    if (!id) return;
    if (!target.dataset.ewSubmenu) {
      if (this._contextMenuSub) this._contextMenuSub.style.display = 'none';
      return;
    }
    this._openSubmenu(id, target);
  }

  _openSubmenu(id, anchorEl) {
    const items = this._ctxMenuSubItems.get(id);
    if (!items || !this._contextMenuSub) return;
    const ctx = this._contextMenuContext();
    const resolved = this._resolveMenuItems(items, ctx);
    this._contextMenuSub.innerHTML = '';
    resolved.forEach((item, index) => {
      const subId = this._menuIdFor(item, `sub-${id}-${index}`);
      const menuItem = { ...item, id: subId };
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ew-context-item';
      btn.dataset.ewMenuId = subId;
      btn.textContent = menuItem.label || menuItem.id;
      if (menuItem.enabled === false) btn.disabled = true;
      this._ctxMenuItemMap.set(subId, menuItem);
      this._contextMenuSub.appendChild(btn);
    });
    this._contextMenuSub.style.display = 'block';
    const container = this._container || document.body;
    const containerRect = container.getBoundingClientRect();
    const menuRect = this._contextMenu.getBoundingClientRect();
    const subRect = this._contextMenuSub.getBoundingClientRect();
    const menuOffsetX = menuRect.left - containerRect.left;
    const menuOffsetY = menuRect.top - containerRect.top;

    let left = this._contextMenuMain.offsetWidth - 2;
    let top = anchorEl.offsetTop;

    const absLeft = menuOffsetX + left;
    if (absLeft + subRect.width > containerRect.width) {
      left = -subRect.width + 2;
    }

    let absTop = menuOffsetY + top;
    const maxAbsTop = containerRect.height - subRect.height - 8;
    if (absTop > maxAbsTop) {
      top = maxAbsTop - menuOffsetY;
      absTop = menuOffsetY + top;
    }
    const minAbsTop = 8;
    if (absTop < minAbsTop) {
      top = minAbsTop - menuOffsetY;
    }

    this._contextMenuSub.style.left = `${left}px`;
    this._contextMenuSub.style.top = `${top}px`;
  }

  _onContextMenuClick(e) {
    const target = e.target instanceof HTMLElement ? e.target.closest('[data-ew-menu-id]') : null;
    if (!target) return;
    const id = target.dataset.ewMenuId;
    if (!id) return;
    const item = this._ctxMenuItemMap.get(id);
    if (!item || item.enabled === false) return;
    if (target.dataset.ewSubmenu) {
      this._openSubmenu(id, target);
      return;
    }
    void this._handleContextMenuAction(item);
  }

  async _handleContextMenuAction(item) {
    const ctx = this._contextMenuContext();
    this._hideContextMenu();
    let result = null;
    if (typeof item.action === 'function') {
      result = item.action(ctx);
    } else if (item.action === 'export-json') {
      result = this.exportGraph();
    } else if (item.action === 'add-node' || item.nodeType || item.component) {
      result = this._spawnNodeFromMenu(item, ctx);
    }
    if (result && typeof result.then === 'function') {
      result = await result;
    }
    if (typeof this._contextMenuConfig?.onAction === 'function') {
      this._contextMenuConfig.onAction({ item, result, context: ctx });
    }
    this.emit('contextmenu:action', { item, result, context: ctx });
  }

  _spawnNodeFromMenu(item, ctx) {
    if (!this.graph) return null;
    const size = item.size || {};
    const w = Number.isFinite(size.w) ? size.w : 320;
    const h = Number.isFinite(size.h) ? size.h : 160;
    const x = ctx.world.x - w / 2;
    const y = ctx.world.y - h / 2;
    const payload = {
      type: item.nodeType || (item.component || item.loader || item.render ? 'html' : 'text'),
      component: item.component || null,
      render: item.render || null,
      loader: item.loader || null,
      text: item.text,
      props: item.props || null,
      data: item.data || null,
      color: item.color ?? null,
      pulse: Boolean(item.pulse),
      x,
      y,
      w,
      h,
      autoPlace: true
    };
    if (item.payload && typeof item.payload === 'object') Object.assign(payload, item.payload);
    const id = this.addNode(payload);
    if (id) this.selectNode(id);
    return id;
  }

  _positionHtmlNode(node, el) {
    const p = this.worldToScreen(node.x, node.y);
    el.style.transformOrigin = 'top left';
    el.style.transform = `translate(${p.x}px, ${p.y}px) scale(${this.camera.s})`;
    el.style.width = `${node.w}px`;
    el.style.height = `${node.h}px`;
    const scale = clampValue(0.85, 2.4, node.h / 180);
    el.style.setProperty('--ew-node-scale', scale.toFixed(3));
  }


  _attachHtmlHandles(record) {
    if (!record?.el) return;
    if (record.handles) return;
    record.handles = {};
    ['nw', 'ne', 'se', 'sw'].forEach((key) => {
      const handle = document.createElement('div');
      handle.className = 'ew-html-handle';
      handle.dataset.ewResize = key;
      record.el.appendChild(handle);
      record.handles[key] = handle;
    });
  }

  _syncHtmlSelection(node, record) {
    if (!record?.el) return;
    const selected = node.id === this.state.selectedId;
    record.el.dataset.ewSelected = selected ? 'true' : 'false';
    record.el.dataset.ewFixed = node.fixed ? 'true' : 'false';
  }

  _removeHtmlNode(id) {
    const record = this._htmlNodes.get(id);
    if (!record) return;
    if (record.cleanup) {
      try {
        record.cleanup();
      } catch (err) {
        console.warn('HTML node cleanup failed', err);
      }
    }
    if (record.el?.parentElement) record.el.parentElement.removeChild(record.el);
    this._htmlNodes.delete(id);
    this._htmlPending.delete(id);
    this._htmlDirty.delete(id);
  }

  _getSvgRecord(node) {
    if (!node) return null;
    const sanitizedSvg = node.svg ? this._sanitizeSvgMarkup(node.svg) : null;
    const key = sanitizedSvg ? `markup:${sanitizedSvg}` : node.svgUrl ? `url:${node.svgUrl}` : null;
    if (!key) return null;
    const existing = this._svgCache.get(node.id);
    if (existing && existing.key === key) return existing;
    if (existing?.url) {
      try {
        URL.revokeObjectURL(existing.url);
      } catch (err) {
        // ignore revoke errors
      }
    }

    const img = new Image();
    img.decoding = 'async';
    if (node.svgUrl) img.crossOrigin = 'anonymous';
    const record = { key, img, loaded: false, error: false, url: null };
    img.onload = () => {
      record.loaded = true;
      record.error = false;
      this._invalidate();
    };
    img.onerror = () => {
      record.error = true;
      this._invalidate();
    };

    if (node.svg) {
      if (!sanitizedSvg) {
        record.error = true;
        this._svgCache.set(node.id, record);
        return record;
      }
      const blob = new Blob([sanitizedSvg], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);
      record.url = url;
      img.src = url;
    } else if (node.svgUrl) {
      img.src = node.svgUrl;
    }

    this._svgCache.set(node.id, record);
    return record;
  }

  _removeSvgNode(id) {
    const record = this._svgCache.get(id);
    if (!record) return;
    if (record.url) {
      try {
        URL.revokeObjectURL(record.url);
      } catch (err) {
        // ignore revoke errors
      }
    }
    this._svgCache.delete(id);
  }

  _clearSvgNodes() {
    Array.from(this._svgCache.keys()).forEach((id) => this._removeSvgNode(id));
  }

  _clearHtmlNodes() {
    Array.from(this._htmlNodes.keys()).forEach((id) => this._removeHtmlNode(id));
  }

  _pulseValue(seed) {
    const hash = this._hashSeed(String(seed));
    const t = performance.now() * 0.004;
    return 0.5 + 0.5 * Math.sin(t + hash);
  }

  _hashSeed(text) {
    let h = 0;
    for (let i = 0; i < text.length; i++) {
      h = (h << 5) - h + text.charCodeAt(i);
      h |= 0;
    }
    return (Math.abs(h) % 1000) / 100;
  }

  _ensurePulseLoop() {
    if (!this.graph) return;
    const hasPulse = this.graph.nodes.some((n) => n.pulse) || this.graph.edges.some((e) => e.pulse);
    if (!hasPulse) {
      this._pulseRaf = null;
      return;
    }
    if (this._pulseRaf) return;
    this._pulseRaf = requestAnimationFrame(() => {
      this._pulseRaf = null;
      if (!this.graph) return;
      const still = this.graph.nodes.some((n) => n.pulse) || this.graph.edges.some((e) => e.pulse);
      if (!still) return;
      this.render();
    });
  }

  _drawWrappedText(text, x, y, maxWidth, baseLineHeight) {
    const ctx = this.ctx;
    ctx.fillStyle = this.theme.nodeText;
    const fontSize = clampValue(6, 20, 13 * this.camera.s);
    const lineHeight = Math.max(fontSize * 1.25, baseLineHeight * this.camera.s);
    ctx.font = `600 ${fontSize}px "Space Grotesk", "Share Tech Mono", monospace`;
    ctx.textBaseline = 'top';
    const words = String(text).split(/\s+/);
    let line = '';
    for (let i = 0; i < words.length; i++) {
      const test = line ? `${line} ${words[i]}` : words[i];
      const m = ctx.measureText(test);
      if (m.width > maxWidth && i > 0) {
        ctx.fillText(line, x, y);
        line = words[i];
        y += lineHeight;
      } else {
        line = test;
      }
    }
    if (line) ctx.fillText(line, x, y);
  }
}

function clampValue(min, max, value) {
  return Math.max(min, Math.min(max, value));
}

